type TableOfContentsKeys =
  | 'BOTTOM_LINE'
  | 'PROS_AND_CONS'
  | 'DETAILED_REVIEW'
  | 'COMPARE_TO_OTHER_CARDS'
  | 'BENEFITS_AND_PERKS'
  | 'DRAWBACKS_AND_CONSIDERATIONS'
  | 'HOW_TO_DECIDE';

export const tableOfContentsMap: Record<TableOfContentsKeys, { id: string; title: string }> = {
  ['BOTTOM_LINE']: {
    id: 'the-bottom-line',
    title: 'The Bottom Line',
  },
  ['PROS_AND_CONS']: {
    id: 'pros-and-cons',
    title: 'Pros and Cons',
  },
  ['DETAILED_REVIEW']: {
    id: 'detailed-review',
    title: 'Detailed Review',
  },
  ['COMPARE_TO_OTHER_CARDS']: {
    id: 'compare-to-other-cards',
    title: 'Compare to Other Cards',
  },
  ['BENEFITS_AND_PERKS']: {
    id: 'benefits-and-perks',
    title: 'Benefits and Perks',
  },
  ['DRAWBACKS_AND_CONSIDERATIONS']: {
    id: 'drawbacks-and-considerations',
    title: 'Drawbacks and Considerations',
  },
  ['HOW_TO_DECIDE']: {
    id: 'how-to-decide-if-its-right-for-you',
    title: `How To Decide If It's Right For You`,
  },
};
